import { applySnapshot, flow } from 'mobx-state-tree';
import { toMapById } from '~/mst/utils';
import api from '~/api';
import { IThreadsModel } from './model';

const actions = (self: IThreadsModel) => ({
  fetch: flow(function* (params) {
    try {
      self.startFetching();
      const { data } = yield api.noesis.fetchThreads(params);
      applySnapshot(self.models, toMapById(data));
      self.finishFetching();
    } catch (e) {
      self.failFetching(e);
    }
  }),
  create: flow(function* create(payload) {
    try {
      self.startSyncing();
      const { data } = yield api.noesis.createThread(payload);
      const threadId = data.id;
      self.add(data);
      self.finishSyncing();
      return threadId;
    } catch (e) {
      self.failSyncing(e);
    }
    return null;
  })
});

export default actions;
